const routes = [
  {
    path: '/users',
    name: 'users-list',
    component: () => import(/* webpackChunkName: "page/users/list" */'@/views/pages/users/List'),
    meta: {
      permissions: 'users_read'
    }
  },
  {
    path: '/users/new',
    name: 'users-new',
    component: () => import(/* webpackChunkName: "page/users/new" */'@/views/pages/users/New'),
    meta: {
      permissions: 'users_write'
    }
  },
  {
    path: '/users/:id',
    name: 'users-single',
    component: () => import(/* webpackChunkName: "page/users/single" */'@/views/pages/users/Single'),
    meta: {
      permissions: 'users_read'
    }
  },
  {
    path: '/users/:id/edit',
    name: 'users-edit',
    component: () => import(/* webpackChunkName: "page/users/edit" */'@/views/pages/users/Edit'),
    meta: {
      permissions: 'users_write'
    }
  },
  // PROFILE
  {
    path: '/profile',
    name: 'profile',
    component: () => import(/* webpackChunkName: "page/users/single" */'@/views/pages/users/Single'),
    meta: {
      permissions: 'users_profile'
    }
  },
  {
    path: '/profile/edit',
    name: 'profile-edit',
    component: () => import(/* webpackChunkName: "page/users/edit" */'@/views/pages/users/Edit'),
    meta: {
      permissions: 'users_profile'
    }
  }
]

export default routes
